module.exports = __webpack_public_path__ + "41f486ed77fe62a28ba8306c1e23c3f6.svg";